{
  "partnerships": {
    "title": "Partnerships",
    "empty": "No Partnerships",
    "leased_to": "Leased Thiamis",
    "shared_to": "Shared Thiamis",
    "shared_devices": "Shared Devices",
    "create_new": "Create Partnership",
    "filter_input": "Filter partnerships...",
    "empty_list": "No partnerships",
    "edit_metadata_title": "Edit Partnership Metadata",
    "add_partnership_help": "Choose existing organization or enter external customer id (ex. AC334455)",
    "metadata": {
      "ref": "Reference"
    }
  }
}
